export default import.meta.ROLLUP_FILE_URL_k2V9yTv_hTNIw9RQF__oKg